<template>
    <div class="container">
        <knowledgeMenu @knowledgeSelect="knowledgeSelect"/>
        <div>
        <div class="introduction">
            <div class="introductionTitle">
                <h1 data-aos="fade-up">iRare罕见病与知识库检索分析系统</h1>
                <div data-aos="fade-up"></div>
                <div data-aos="fade-up">
                  iRare罕见病与知识库检索分析系统的主要目标人群为14 岁以下的儿童，主要使用者为医院医生和临末遗传咨询师，识别部位主要为用户的面部。对于具有明显面部特征的人群，通过拍摄或上传一张清晰的脸部正面照片，系统会根据后台的人工智能算法识别出被扫描者患有罕见病的风险级别(低、中、高)，并给出可能患有的罕见病的排序以及可能性，针对普通人群，可利用此系统进行大规模的筛查，筛查结果主要推送给医生或临床遗传咨询师。根据筛查结果，并与基因检测结合，帮助诊断出罕见病患者。
                </div>
            </div>
            <div data-aos="zoom-out">
                <img :src="require('@/assets/img/knowledge/rare/rareTitle.png')" alt="">
            </div>
        </div>
        <div data-aos="zoom-out">
            <img :src="require('@/assets/img/knowledge/rare/banner.png')" alt="" style="width: 100%">
        </div>
        <div class="function">
            <div class="title" data-aos="fade-up">功能示例</div>
            <div class="content">
                <div v-for="item,index in functionList" >
                    <div :data-aos="index%2===0?'fade-right':'fade-left'"><span>{{item.title}}</span></div>
                    <img :src="item.img" alt="" data-aos="zoom-in">
                    <div class="text" :data-aos="index%2===0?'fade-right':'fade-left'">{{item.content}}</div>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import knowledgeMenu from "../../components/knowledgeMenu";
export default {
    name:'Share',
    components: {
	    knowledgeMenu
    },
    data(){
      return {
           functionList:[
            {
                title:'面部表型处理',
                img:require('@/assets/img/knowledge/rare/function1.png'),
                content:'上传面部照片，系统自动识别出相关表型。'
            },
            {
                title:'临床表型处理',
                img:require('@/assets/img/knowledge/rare/function2.png'),
                content:'可以查看到基于HPO的面部表型、非面部表型的具体信息；根据面部照片自动预测罕见病风险值以及疾病预测列表。'
            },
            {
                title:'知识库表型查询',
                img:require('@/assets/img/knowledge/rare/function3.png'),
                content:''
            },
            {
                title:'知识库疾病查询',
                img:require('@/assets/img/knowledge/rare/function4.png'),
                content:''
            },
            {
                title:'知识库内容检索',
                img:require('@/assets/img/knowledge/rare/function5.png'),
                content:'疾病预测信息包括基于 OMIM的OMIMID、疾病中英文名称、可能性，并能查看该疾病的中英文详情，涵盖分子遗传学、发病机理、细胞遗传学、临床特征、基因型-表型相关性、群体遗传学等。'
            },
            {
                title:'',
                img:require('@/assets/img/knowledge/rare/function6.png'),
                content:''
            },
        ]
      }
    },
    methods:{
        knowledgeSelect(src){
	        this.$emit('knowledgeSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
    .container{
        width: 100%;
        padding-left: 20%;
        box-sizing: border-box;
        position: relative;
    }
    .introduction{
        width: 1071px;
        margin: 178px auto 0;
        display: flex;
        justify-content: space-between;
        .introductionTitle{
            width: 515px;
            font-family: SourceHanSansCN-Normal;
            font-size: 15px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 25px;
            letter-spacing: 1px;
            h1{
                font-size: 19px;
            }
            &>div:nth-child(2){
                width: 65px;
                height: 3px;
                background: #006efd;
                margin: 13px 0 50px 0px;
            }
            &>div:nth-child(3),&>div:nth-child(4){
                font-size: 15px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 25px;
                letter-spacing: 1px;
                color: #333333;
                text-indent: 2em;
            }
        }
    }
    .function{
        margin-top: 100px;
        .title{
            width: 284px;
            height: 67px;
            margin: 0 auto;
            background: url("../../assets/img/knowledge/rare/functionTitle.png");
            font-size: 30px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 24px;
            letter-spacing: 2px;
            color: #ed1c24;
            text-align: center;
        }
        .content{
            width: 1033px;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            margin: 0 auto;
            &>div{
                width: 443px;
                margin-bottom: 50px;
                div:nth-child(1){
                    span{
                        padding: 3px 16px;
                        background-color: #006efd;
                        text-align: center;
                        font-size: 20px;
                        font-weight: normal;
                        font-stretch: normal;
                        line-height: 47px;
                        letter-spacing: 2px;
                        color: #ffffff;
                        box-sizing: border-box;
                    }
                }
                img{
                    margin: 15px 0;
                }
                .text{
                    font-size: 15px;
                    font-weight: normal;
                    font-stretch: normal;
                    line-height: 25px;
                    letter-spacing: 2px;
                    color: #333333;
                }
            }
            &>div:last-child{
                div:nth-child(1) {
                    span {
                        background: none;
                    }
                }
            }
        }
    }
</style>
